import account from './account';
import center from './center';
import doctor from './doctor';
import drug from './drug';
import event from './event';
import general from './general';
import patient from './patient';
import stat from './stat';
import stock from './stock';
import validator from './validator';

export default {
  account,
  center,
  doctor,
  drug,
  event,
  general,
  patient,
  stat,
  stock,
  validator,
}
